import { render, staticRenderFns } from "./foter.vue?vue&type=template&id=2deb51c6&scoped=true"
import script from "./foter.vue?vue&type=script&lang=js"
export * from "./foter.vue?vue&type=script&lang=js"
import style0 from "./foter.vue?vue&type=style&index=0&id=2deb51c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deb51c6",
  null
  
)

export default component.exports